import { Parrot } from './Parrot';

export const UnderConstruction = () => (
  <div className="flex flex-col gap-12 justify-center items-center">
    <h2 className="font-bold text-4xl text-center text-pt-primary dark:text-pt-yellow">
      This page is still under construction
    </h2>

    <Parrot className="w-96" type="flying" />
  </div>
);
